import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService, CommunicationConfigService } from '@argalis-apps/angular-global';
import { MDomain, MFormation, MSearch, MModalite, MDuree } from '@argalis-apps/models';
import { DomainService, DureeService, ModaliteService } from '@argalis-apps/angular-services';
import { CatalogConfigService } from '../catalog-config/catalog-config.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  constructor(
    private configService: ConfigService,
    private catalogConfigService: CatalogConfigService,
    private communicationConfigService: CommunicationConfigService,
    private domainService: DomainService,
    private dureeService: DureeService,
    private http: HttpClient,
    private modaliteServive: ModaliteService
  ) {}

  getDomOptionList(): Observable<MDomain.IDomain[]> {
    return this.domainService.get();
  }

  getModaOptionList(): Observable<MModalite.IModalite[]> {
    return this.modaliteServive.get();
  }

  getDureeOptionList(): Observable<MDuree.IDuree[]> {
    return this.dureeService.get();
  }

  searchForForms(
    searchOptions: MFormation.IFormSearchParams
  ): Observable<MSearch.ISearchResult<MFormation.IFormOverview>> {
    if (this.configService.getOptions().useTestData) {
      return of({
        matchCount: 7,
        matchList: [
          {
            id: 1,
            libelle: 'Ma formation de test 1',
            modalite: [1],
            duree: 3,
            description: 'Description de ma formation de test 1',
            nbSessions: 1,
            bParcours: false
          },
          {
            id: 2,
            libelle: 'Ma formation de test 2',
            modalite: [3],
            duree: 1,
            description: 'Description de ma formation de test 2',
            nbSessions: 3,
            bParcours: true
          },
          {
            id: 3,
            libelle: 'Ma formation de test 3',
            modalite: [1],
            duree: 2,
            description: 'Description de ma formation de test 3',
            nbSessions: 0,
            bParcours: false
          },
          {
            id: 4,
            libelle: 'Ma formation de test 4',
            modalite: [1],
            duree: 8,
            description: 'Description de ma formation de test 4',
            nbSessions: 1,
            bParcours: false
          },
          {
            id: 5,
            libelle: 'Ma formation de test 5',
            modalite: [2],
            duree: 20,
            description: 'Description de ma formation de test 5',
            nbSessions: 0,
            bParcours: true
          },
          {
            id: 6,
            libelle: 'Ma formation de test 6',
            modalite: [3],
            duree: 13,
            description: 'Description de ma formation de test 6',
            nbSessions: 3,
            bParcours: false
          }
        ],
        secondSearch: false
      });
    } else {
      let params = new HttpParams();
      // for (const param of Object.keys(searchOptions)) {
      //   params.set(param, searchOptions[param]);
      // }
      for (const key in searchOptions) {
        if (searchOptions.hasOwnProperty(key)) {
          params = params.set(key, searchOptions[key]);
        }
      }
      return this.http.get<MSearch.ISearchResult<MFormation.IFormOverview>>(
        `${this.communicationConfigService.getApiUri()}/catalog/search`,
        { params }
      );
    }
  }

  getBackgroundPicture(): Observable<string> {
    return this.http.get<any>(`${this.communicationConfigService.getApiUri()}/config/background`);
  }
}
